import { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { processSteps } from "../mock";

const StepsSection = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    const cards = ref.current?.querySelectorAll(".reveal") || [];
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="ws-steps" ref={ref}>
      <div className="ws-steps-inner">
        <span className="ws-tag"><span className="dot" />SAMENWERKEN MET WS GLOBAL TRADING</span>
        <h2>Zo werken we samen, in vier stappen</h2>
        <div className="ws-steps-grid">
          {processSteps.map((step, i) => (
            <div
              key={step.step}
              className="ws-step-card reveal"
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              <span className="ws-step-label">{step.step}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
              {i < processSteps.length - 1 && (
                <span className="step-arrow">
                  <ArrowRight size={22} />
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
